<template>
  <transition class="slide" name="slide">
    <div class="tooltip-container full-width text-xs-center" v-show="value">
      <v-card
        class="disclaimer-card mb-2 pt-5 px-2"
        flat
      >
        <v-card-text class="caption" v-html="text">
        </v-card-text>
      </v-card>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'wf-disclaimer-tooltip',
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      text: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style scoped lang="scss">
  .disclaimer-card {
    text-align: left;
    background-image: url('../assets/combined_shape.png');
    background-size: 150%;
    width: 105%;
    margin-left: -2.5%;
  }

  .slide-enter-active {
    transition: max-height 1s;
  }

  .slide-leave-active {
    transition: max-height 0.2s;
  }

  .slide-leave, .slide-enter-to {
    max-height: 600px;
  }

  .slide-enter, .slide-leave-to {
    max-height: 0;
  }

  .tooltip-container {
    overflow: hidden;
  }

</style>
